import React, {useState} from 'react';
import {Checkbox, FlexRow, Label, Modal, Text} from '@forecast-it/design-system';
import {FormattedMessage, useIntl} from 'react-intl';
import {createToast} from '../../../../shared/components/toasts/another-toast/toaster';
import {ReportRow} from '../../ReportTypes';

type BulkShareReportModalProps = {
	closeModal: () => void;
	reports: ReportRow[];
	changePrivateAccess: (successCallback: (result) => void, ids: string[], privateAccess: boolean) => void;
};

const BulkShareReportModal = ({closeModal, reports, changePrivateAccess}: BulkShareReportModalProps): React.JSX.Element => {
	const intl = useIntl();
	const ids = reports.filter(report => report.reportService).map(report => report.id);
	const allHavePrivateAccess = reports.every(rep => rep.privateAccess);

	const [privateAccess, setPrivateAccess] = useState<boolean>(allHavePrivateAccess);

	const togglePrivateAccess = () => {
		setPrivateAccess(!privateAccess);
	};

	const saveChanges = () => {
		const onSuccess = () => {
			if (privateAccess) {
				createToast({
					duration: 5000,
					message: intl.formatMessage({id: 'shared_report.bulk_report_made_private'}, {reportCount: reports.length}),
				});
			} else {
				createToast({
					duration: 5000,
					message: intl.formatMessage(
						{id: 'shared_report.bulk_report_shared_with_organisation'},
						{reportCount: reports.length}
					),
				});
			}
		};
		changePrivateAccess(onSuccess, ids, privateAccess);
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.MEDIUM} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'report.share'} />
			</Modal.Title>
			<Modal.Content>
				<Label>{intl.formatMessage({id: 'report.share-company-label'})}</Label>
				<FlexRow>
					<Checkbox checked={!privateAccess} onChange={togglePrivateAccess}></Checkbox>
					<Text>{intl.formatMessage({id: 'report.private_access.description'})}</Text>
				</FlexRow>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={saveChanges} dataCy={'modal-btn-done'}>
					<FormattedMessage id="common.save" />
				</Modal.PrimaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default BulkShareReportModal;
